var link_viewer_default = {
  "fontElementMap": "lw9Mr",
  "link": "KuPfL",
  "linkInEditor": "bRzKH",
  "linkInViewer": "ggJuS",
  "toolbarUrlContainer": "AMi35",
  "toolbarUrl": "p7WoA",
  "toolbarUrlAnchor": "b-maN"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
